<template>
  <form-popover
    @submit="submit"
    :parent="parent"
    :direction="direction"
  >
    <div>
      <label class="form-popover__label" tabindex="1">{{formLabel}}</label>
      <input class="form-popover__input" v-model='valueInput' autofocus tabindex="2">
    </div>
  </form-popover>
</template>

<script>
import FormPopover from './FormPopover'

export default {
  components: {
    FormPopover
  },
  props: {
    direction: String,
    parent: HTMLDivElement,
    onSubmit: Function,
    formLabel: String
  },
  data: () => {
    return {
      valueInput: ''
    }
  },
  mounted () {
    document.getElementsByClassName('form-popover__input')[0].focus()
  },
  methods: {
    submit () {
      this.onSubmit(this.valueInput)
      this.dismiss()
    }
  }
}
</script>

<style>
.form-popover__label {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// InputFormPopover.vue?56a13418